export const COOKIE_HANBIRO_GW = 'HANBIRO_GW';